module.exports = __webpack_public_path__ + "static/privileged-question-4f2f9f2770e6aa7c8eebeb7587857c38.png";